// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-index-tsx": () => import("/home/jenkins/workspace/Release_android-china-site_main/src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */)
}

